import React from "react";
import { useTranslation } from "react-i18next";
import { LastActionStatus } from "../../../../models/last-action-status.enum";
import { SectionBlock, Title } from "../../talent.styled";
import { Status } from "././feedback-status.styled";
import { selectedSchema } from "../../../home-components/table/components/selected-status/selected-status.utils";


interface FeedbackStatusProps {
  status: LastActionStatus;
}

const FeedbackSchema = selectedSchema;

const FeedbackStatus: React.FC<FeedbackStatusProps> = ({ status }) => {
  const { t } = useTranslation(["translation", "private-home-page"]);

  return (
    <SectionBlock>
      <Title>{t("private-home-page:talent.status")}</Title>
      <div>
        <Status
          color={FeedbackSchema[status].color}
        >
          <p>{t(FeedbackSchema[status].title)}</p>
        </Status>
      </div>
    </SectionBlock>
  );
};

export default FeedbackStatus;
